import React, { PropTypes } from 'react';
import Consts from '../../../Consts';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: this.props.hidden
    }
    this.hide = this.hide.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({ hidden: newProps.hidden });
  }

  hide(event) {
    event.preventDefault();
    this.props.hide()
    this.setState({ hidden: true })
  }

  render() {
    return (
      <div className={'c-Modal' + (this.state.hidden ? " u-display-none" : "")}>
        <div className="c-Modal-content u-height-100vh u-flex u-flex-column">
          <div className="c-Modal-header">
            <h4>{this.props.title}</h4>
            <div className="c-Modal-cross">
              <a href="#" onClick={this.hide}><img src={Consts.baseDir + "images/modal-cross.png"} /></a>
            </div>
          </div>
          <div style={{flex: "100%"}} dangerouslySetInnerHTML={{ __html: this.props.text }}></div>  
          <a href="#" onClick={this.hide}>{this.props.closeButtonText}</a>        
        </div>        
      </div>
    );
  }
}

Popup.propTypes = {
  title: React.PropTypes.string.isRequired,
  text: React.PropTypes.string.isRequired,
  closeButtonText: React.PropTypes.string.isRequired,
  hidden: React.PropTypes.bool,
  hide: React.PropTypes.func.isRequired

};


export default Popup;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/Popup.js
 **/